import React from 'react';

const hex2rgb = hex => [...hex.match(/\w\w/g)].map(x => parseInt(x, 16)).join(',');

export const VerticalCardWithIcon = ({iconClassName, header, content = '', headerClassName = '', color = '#000000'}) => (
  <div className='card'>
    <div className='card-content'>
      <div className='card-body cleartfix'>
        <div className='media align-items-stretch'>
          <div className='align-self-center'>
            <i className={iconClassName} style={{color: color, background: `rgb(${hex2rgb(color)}, 0.1)`}}/>
          </div>
          <div className='media-body'>
            <h4 dangerouslySetInnerHTML={{__html: header}} className={headerClassName} />
            <span dangerouslySetInnerHTML={{__html: content}} />
          </div>
        </div>
      </div>
    </div>
  </div>
);
